import React, {Component} from 'react';
import ListDesignerHoc from "../../../HocHelpers/ListDesignerHoc";
import withStyles from "@material-ui/core/styles/withStyles";
import {Button, Divider, Paper} from "@material-ui/core";
import ExpansionPanels from "./ExpansionPanels/ExpansionPanels";
import classNames from "classnames";

const styles = () => ({
    wrapper: {
        height: '100%',
        width: 350,
    },
    wrapperModal: {
        height: '100%',
        width: 350,
    },
    flexWrapper: {
        // display: 'flex',
        //   flexDirection: 'column'
    },
    expansionPanelWrapper: {
        height: 'calc(100% - 40px)',
        overflowY: 'auto',
        overflowX: 'hidden',
    },
    screenActionWrapper: {
        height: '40px',
    },
    button: {
        marginLeft: 7
    },
    buttonGroup: {
        marginTop: 5
    }
});


class ToolBar extends Component {
    render() {
        const {classes, deleteList, closeList, saveList, modal} = this.props;
        return (
            <Paper className={modal ? classes.wrapperModal : classes.wrapper}>
                <div className={classNames(classes.expansionPanelWrapper, 'expansionPanelWrapper')}>
                    <ExpansionPanels/>
                </div>
                <div>
                    <div className={classes.screenActionWrapper}>
                        <Divider/>
                        <div className={classes.buttonGroup}>
                        <Button className={classes.button}
                                variant={"contained"}
                                size={"small"}
                                color={"primary"}
                                onClick={saveList}>Save</Button>
                        <Button className={classes.button}
                                variant={"contained"}
                                size={"small"}
                                onClick={deleteList}>Delete</Button>
                        <Button className={classes.button}
                                variant={"contained"}
                                size={"small"}
                                onClick={closeList}>Cancel</Button>
                        </div>

                    </div>
                </div>
            </Paper>
        );
    }
}

export default ListDesignerHoc(withStyles(styles)(ToolBar));